import React from 'react'
import PropTypes from 'prop-types'
import Option from './Option'
import Flag from 'components/Flag'

const CurrencyOption = ({ data: { flag, abbreviature, name, isCrypto }, ...props }) => {
    const windowWidth = window.innerWidth
    const breakPoint = 550

    return <Option {...props} >
		<Flag className='u-margin-right-small' src={flag} alt={name} isCrypto={isCrypto} />
		<span>{ windowWidth >= breakPoint ? `${abbreviature} - ${name}` : abbreviature }</span>
	</Option>
}

CurrencyOption.propTypes = {
	flag: PropTypes.string,
	label: PropTypes.string,
	name: PropTypes.string,
}

export default CurrencyOption